export default __webpack_public_path__ + "static/media/Casualshirts.0ead32dd.png";